import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import LegalLayout from './LegalLayout';
import ThemeContext from '../../context/ThemeContext';

const LegalHub = () => {
  const { theme } = useContext(ThemeContext) || {};
  const isDark = theme === 'dark';

  const documents = [
    {
      title: "Conditions Générales d'Utilisation",
      description: "Règles d'utilisation du service, droits et obligations des utilisateurs.",
      link: "/legal/cgu",
      icon: "file-contract",
      updated: "Mise à jour récente"
    },
    {
      title: "Mentions Légales",
      description: "Informations légales sur l'éditeur et l'hébergeur du site.",
      link: "/legal/mentions-legales",
      icon: "balance-scale",
      updated: "Mise à jour récente"
    },
    // Placeholder for future documents
    {
      title: "Politique de Confidentialité",
      description: "Informations sur la collecte, le traitement et la protection de vos données personnelles.",
      link: "/legal/privacy",
      icon: "shield-alt",
      updated: "Mise à jour récente"
    },
    {
      title: "Conditions Générales de Vente",
      description: "Modalités de paiement, abonnements et politique de remboursement.",
      link: "/legal/cgv",
      icon: "shopping-cart",
      updated: "Mise à jour récente"
    }
  ];

  return (
    <LegalLayout 
      title="Centre Juridique" 
      subtitle="Retrouvez ici l'ensemble des documents légaux régissant l'utilisation de Muzo Studio."
    >
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {documents.map((doc, index) => (
          <Link 
            key={index}
            to={doc.link}
            className={`group relative p-6 rounded-xl border transition-all duration-300 hover:-translate-y-1 hover:shadow-lg ${
              isDark 
                ? 'bg-slate-800/50 border-slate-700 hover:border-indigo-500/50 hover:bg-slate-800' 
                : 'bg-white border-slate-200 hover:border-indigo-500/50 hover:bg-slate-50'
            } ${doc.status ? 'cursor-not-allowed opacity-75' : ''}`}
            onClick={e => doc.status && e.preventDefault()}
          >
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center mb-4 text-xl ${
              isDark ? 'bg-slate-700 text-indigo-400' : 'bg-indigo-50 text-indigo-600'
            }`}>
              <FontAwesomeIcon icon={doc.icon} />
            </div>
            
            <h3 className={`text-lg font-semibold mb-2 ${
              isDark ? 'text-slate-100' : 'text-slate-900'
            }`}>
              {doc.title}
            </h3>
            
            <p className={`text-sm mb-4 line-clamp-3 ${
              isDark ? 'text-slate-400' : 'text-slate-600'
            }`}>
              {doc.description}
            </p>

            <div className="flex items-center justify-between mt-auto">
              {doc.status ? (
                <span className={`text-xs px-2 py-1 rounded-full ${
                  isDark ? 'bg-slate-700 text-slate-400' : 'bg-slate-100 text-slate-500'
                }`}>
                  {doc.status}
                </span>
              ) : (
                <span className={`text-xs font-medium flex items-center gap-1 ${
                  isDark ? 'text-indigo-400' : 'text-indigo-600'
                }`}>
                  Lire le document
                  <FontAwesomeIcon icon="arrow-right" className="w-3 h-3 transition-transform group-hover:translate-x-1" />
                </span>
              )}
            </div>
          </Link>
        ))}
      </div>
    </LegalLayout>
  );
};

export default LegalHub;
